export const FETCH_LOGIN = "FETCH_LOGIN";
export const FETCH_LOGIN_PENDING = "FETCH_LOGIN_PENDING";
export const FETCH_LOGIN_REJECTED = "FETCH_LOGIN_REJECTED";
export const FETCH_LOGIN_FULFILLED = "FETCH_LOGIN_FULFILLED";

export const FETCH_LOGOUT = "FETCH_LOGOUT";
export const FETCH_LOGOUT_PENDING = "FETCH_LOGOUT_PENDING";
export const FETCH_LOGOUT_REJECTED = "FETCH_LOGOUT_REJECTED";
export const FETCH_LOGOUT_FULFILLED = "FETCH_LOGOUT_FULFILLED";
